// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8c386b1e","239":"d4ce67fa","455":"e5bea7ee"}[chunkId] + ".chunk.js";
};